module.exports = __webpack_public_path__ + "static/media/Mock.683ed10d.png";